import React, { useReducer } from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { BreadCrumbsContainer } from '../BreadCrumbs';
import { AddBlogPostForm } from '../../components/AddPostForm';
import { Title as TitleField } from '../../components/AddPostFormFields';
import { blogPostFormReducer, initialState, useTitleField } from '../../utils/postForm';

/**
 * Контейнер формы добавления/редактирования поста блога
 */
export const AddBlogPostFormContainer = () => {
  const [dispatch, state] = useReducer(blogPostFormReducer, initialState);
  const titleProps = useTitleField(dispatch, state);

  return (
    <>
      <BreadCrumbsContainer />
      <AddBlogPostForm heading={<UIHeading1>Новая запись</UIHeading1>} titleField={<TitleField {...titleProps} />} />
    </>
  );
};
